import { useMemo } from 'react';

import { TaskActivity } from '@/v2/domains/Tasks/types/task';
import { ACTIVITY_TYPES } from '@/v2/domains/Activities/constants/types';
import useGetReinforcementActivityDataQuery from '@/v2/domains/Student/Tasks/queries/useGetReinforcementActivityDataQuery.hook';

export default function useReinforcementActivity({
  taskActivity,
  activity,
}: {
  taskActivity: TaskActivity;
  activity: any;
}) {
  const isReinforcement =
    taskActivity?.activity?.type == ACTIVITY_TYPES.reinforcement;

  const { data, isLoading } = useGetReinforcementActivityDataQuery({
    taskActivityId: taskActivity?.id,
    enabled: isReinforcement,
  });

  const reinforcementActivity = useMemo(() => {
    if (!isReinforcement || !activity) {
      return activity;
    }

    return data ? { ...activity, data } : null;
  }, [activity, isReinforcement, data]);

  return { activity: reinforcementActivity, isLoading };
}
